// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"36cda226","513":"0659dcd3","703":"e518579c"}[chunkId] + ".chunk.js";
};